import { REGIME_SCHEDULE_TOTAL_EXPLANATION } from "./regime-schedule-counts-constants.mjs"
import { useListedRegimeScheduleTotal } from "./use-listed-regime-schedule-total"

// Keyboard and screen reader users focus the whole row or card, so they hear the count and the tooltip's
// explanation from here instead of the tooltip.
export function ListRegimeScheduleDescription() {
    const total = useListedRegimeScheduleTotal()
    if (!total) return null
    const noun = total.count === 1 ? "schedule" : "schedules"
    return `${total.count.toLocaleString("en-GB")} ${total.label.toLowerCase()} ${noun}. ${REGIME_SCHEDULE_TOTAL_EXPLANATION}`
}
